/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { CaseType } from '@brands/services/cases/types/ICase';
import { Pricings } from '@brands/services/identity/getPricings';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { needsPayment } from '@brands/Utils/needsPayment';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Button } from '@mui/material';
import React from 'react';

import Container from '../../../../Components/Container/Container';
import { useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import styles from './styles.module.scss';

const ImageUploadMobile = (): JSX.Element => {
  const roleNavigate = useRoleNavigate();
  const { values, isFromSmileScanReport } = useAppSelector(selectPatientForm);
  const { currentOrganizationPrices } = useAppSelector(selectOrganizationPrices);
  const screenSize = useWindowSize();

  const searchParams = new URLSearchParams(location.search);
  const routeCaseType = searchParams.get('case_type');
  const caseType: string = !routeCaseType
    ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string)
    : routeCaseType;
  const currentOrganizationPrice = currentOrganizationPrices?.find((currentPrice: Pricings) =>
    currentPrice.case_types.includes(caseType as string),
  );

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
      }}
      childrenStyle={{ zIndex: '2' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={styles.uploadImageContainer}>
        <div className={styles.uploadImageContainerDiv}>
          <PatientIntakeNavigation progress={68} />
          <div className={`fs-unmask ${styles.uploadImageQRContainer}`}>
            <div className={styles.uploadImageContainerDivFirstLeft}>
              <span className={`fs-unmask ${styles.uploadImageContainerDivFirstLeftHeader}`}>
                Help us prepare for your virtual appointment
              </span>
              <span className={`fs-unmask ${styles.getReady}`}>
                Get ready for your appointment by sharing clear photos of your mouth! These help your dentist:
              </span>
              <ul className={`fs-unmask ${styles.bolletList}`}>
                <li>Save time during your visit.</li>
                <li>Better understand your needs.</li>
                <li>Create a personalized care plan.</li>
              </ul>
              <span className={`fs-unmask ${styles.itsEasy}`}>It’s easy!</span>
              <ul className={styles.numberedList}>
                <li>Use your smartphone to take clear, well-lit photos of your teeth, gums, and concerns.</li>
                <li>Upload securely through our app.</li>
              </ul>
              <span className={styles.final}>
                Already have photos of your teeth and mouth?
                <span className={styles.finalLink} onClick={() => roleNavigate('/upload-image-flow')}>
                  Tap here{' '}
                </span>
                to upload.
              </span>
            </div>
            <div className={styles.btnContainer}>
              <Button
                type="button"
                className={`fs-unmask ${styles.next}`}
                onClick={() => roleNavigate('/upload-image-flow-step-one', {})}
              >
                Next
              </Button>
              {(values.find((item) => item.form_question_id === 20)?.value.caseType as string) !==
                CaseType.one_report &&
                (values.find((item) => item.form_question_id === 20)?.value.caseType as string) !==
                  CaseType.second_opinion &&
                !isFromSmileScanReport && (
                  <div className={`${styles.btnContainer} ${styles.btnContainerSkip}`}>
                    <Button
                      type="button"
                      className={`fs-unmask ${styles.skipButton}`}
                      variant="text"
                      onClick={() =>
                        roleNavigate(
                          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
                            CaseType.clinical_enablement
                            ? '/clinical-data'
                            : needsPayment(currentOrganizationPrice)
                            ? '/payment-information'
                            : '/confirm-payment',
                        )
                      }
                    >
                      Skip
                      <NavigateNextIcon />
                    </Button>
                    <Button
                      variant="text"
                      className={`fs-unmask ${styles.medicalHistoryFooterBack}`}
                      onClick={() => roleNavigate(-1)}
                    >
                      <ArrowBackIosNewIcon />
                      Back
                    </Button>
                  </div>
                )}
              {(values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'one_report' && (
                <div className={styles.btnContainer}>
                  <Button
                    variant="text"
                    className={`fs-unmask ${styles.medicalHistoryFooterBack}`}
                    onClick={() => roleNavigate(-1)}
                  >
                    <ArrowBackIosNewIcon />
                    Back
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default ImageUploadMobile;
